/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Menu Icon
 */
import _ from 'lodash';
import { Table, PeopleSafe, Wallet, ListBottom, FileFocus } from '@icon-park/react';

import AllCodes from 'components/app/icons/AllCodes';
import Claims from 'components/app/icons/Claims';

const CUSTOM_ICONS = {
	AllCodes,
	Claims,
};

/**
 * Icon Map
 */
const ICON_MAP: Menu.IconMap = {
	Table,
	PeopleSafe,
	Wallet,
	ListBottom,
	FileFocus,
	...CUSTOM_ICONS,
};

/**
 * Get Menu Icon
 * @param {string} icon - Icon
 */
const getMenuIcon = (icon: string): React.ReactNode => {
	const Item = _.get(ICON_MAP, icon);

	if (Item) {
		return <Item size={16} />;
	}
	return null;
};

export { getMenuIcon };
